webpackJsonp([262913539849885],{

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentContainer = __webpack_require__(64);
	
	var _ContentContainer2 = _interopRequireDefault(_ContentContainer);
	
	var _Section = __webpack_require__(65);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var post = data.markdownRemark;
	
	  return _react2.default.createElement(
	    _ContentContainer2.default,
	    null,
	    _react2.default.createElement(
	      _Section2.default,
	      {
	        name: 'privacy'
	      },
	      _react2.default.createElement(
	        'h2',
	        { className: 'title is-size-3 has-text-primary is-bold-light' },
	        post.frontmatter.title
	      ),
	      _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: post.html } })
	    )
	  );
	};
	
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-privacy-js-3f35a88c504fcffb47d7.js